// =============================================================================
// SimSense — iRacing Account Link Gate
// =============================================================================
// Shown to authenticated users who haven't linked an iRacing account yet.
// Starts the real iRacing OAuth linking flow via /api/ss/auth/iracing/link.

import { useState } from "react";
import { useAuthStore } from "../state/authStore";
import "./IracingLinkGate.css";

export function IracingLinkGate() {
  const [linking, setLinking] = useState(false);
  const logout = useAuthStore((s) => s.logout);

  const handleLink = () => {
    setLinking(true);
    window.location.href = "/api/ss/auth/iracing/link";
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="iracing-gate">
      <div className="iracing-gate-card">
        <div className="iracing-gate-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </div>
        <h1>Link Your iRacing Account</h1>
        <p>
          SimSense uses your iRacing identity to personalize telemetry analysis,
          coaching, and leaderboards. Link your account to get started.
        </p>
        <button
          className="iracing-gate-btn"
          onClick={handleLink}
          disabled={linking}
        >
          {linking ? "Redirecting to iRacing..." : "Link iRacing Account"}
        </button>
        <button className="iracing-gate-logout" onClick={handleLogout}>
          Sign out instead
        </button>
      </div>
    </div>
  );
}
